import React from 'react';
import KeyValueCard from '@components/system/KeyValueCard/KeyValueCard';
import {Card, CardContent, Typography, makeStyles} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {Insurance} from './EligibilityVerificationMapper';
import {CARD_BOX_SHADOW} from 'src/style/variable';
import HelperUtils from '@shared/utils/HelperUtils';

const insuranceCardStyles = makeStyles(() => ({
  cardRoot: {
    '& .MuiCardContent-root:last-child': {
      paddingBottom: '13px'
    },
    flex: 1,
    boxShadow: CARD_BOX_SHADOW,
    borderRadius: '1rem'
  },
  section: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    fontSize: '1.3rem',
    fontWeight: 600,
    paddingBlock: '1rem'
  }
}));

interface InsuranceCardProps {
  insurance: Insurance;
  effectiveDate: string | null;
}

const InsuranceCard = ({
  insurance,
  effectiveDate
}: InsuranceCardProps): JSX.Element => {
  const classes = insuranceCardStyles();
  const {t} = useTranslation();
  const insuranceData = [
    {
      label: t('ELIGIBILITY_VERIFICATION.PAYER_NAME'),
      value: insurance?.payer_name ? insurance?.payer_name : '-'
    },
    {
      label: t('ELIGIBILITY_VERIFICATION.SUBSCRIBER_GROUP_NUMBER'),
      value: insurance?.subscriber_group_no
        ? insurance?.subscriber_group_no
        : '-'
    },
    {
      label: t('ELIGIBILITY_VERIFICATION.SUBSCRIBER_MEMBER_NUMBER'),
      value: insurance?.subscriber_member_no
        ? insurance?.subscriber_member_no
        : '-'
    },
    {
      label: t('ELIGIBILITY_VERIFICATION.EFFECTIVE_DATE'),
      value: effectiveDate ? HelperUtils.formatDisplayDate(effectiveDate) : '-'
    }
  ];
  return (
    <div className={`section-header ${classes.section}`}>
      <Typography className={classes.title}>
        {t('ELIGIBILITY_VERIFICATION.INSURANCE')}
      </Typography>
      <Card className={`${classes.cardRoot} card`}>
        <CardContent>
          <KeyValueCard data={insuranceData} />
        </CardContent>
      </Card>
    </div>
  );
};

export default InsuranceCard;
